export enum PaymentSchedule {
    Fixed = 'fixed',
    Increasing = 'increasing',
    Changing = 'changing',
}
